import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';
import classNames from 'classnames';
import React from 'react';
import { useJapanesePremiumExperience } from '../../hooks/useJapanesePremiumExperience';
import styles from './FeaturesGrid.scss';
import { FeaturesGridFeatureRowValue } from './FeaturesGridFeatureRowValue';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';

interface FeaturesGridFeatureRowCellProps {
  productId: string;
  feature: CreativeOffer.GridFeature;
}

export const FeaturesGridFeatureRowCell: React.FC<
  FeaturesGridFeatureRowCellProps
> = ({ productId, feature }) => {
  const isJapanesePremiumExperience = useJapanesePremiumExperience();
  const { data: product, isLoading } =
    EclipsePackagePickerModule.SDK.eclipseOfferingApiClient.hooks.useFetchProduct(
      {
        productId,
      },
    );

  if (isLoading) {
    return null;
  }

  return (
    <PlatformFeaturesGrid.Content.FeatureRow.Cell
      className={classNames(styles.featureRowCell, {
        [styles.recommendedCell]: product?.isRecommended,
        [styles.jpFeatureRowCell]: isJapanesePremiumExperience,
      })}
      overflow={isJapanesePremiumExperience ? 'visible' : undefined}
      paddingTop={isJapanesePremiumExperience ? 'SP1' : undefined}
      paddingBottom={isJapanesePremiumExperience ? 'SP1' : undefined}
    >
      <FeaturesGridFeatureRowValue
        comparisonValue={feature.values?.[productId ?? '']}
      />
    </PlatformFeaturesGrid.Content.FeatureRow.Cell>
  );
};
